module.exports = __webpack_public_path__ + "static/see-the-person-right-19de61eece6b7a3fcecfe887fa8a15a6.png";